<app-dashboard-template>
  <p-toast key="toastMessage" />
  <div class="realtime-container">
    <!-- Red Header with FuelTech Logo -->
    <div class="fueltech-header">
      <div class="header-content">
        <span class="caravana-text">{{ "caravan.header" | transloco }}</span>
        <img src="assets/img/ftvelopark/logoFTVelopark.svg" alt="FuelTech" class="fueltech-logo">
        <span class="ao-vivo-text">{{ "caravan.live" | transloco }}</span>
      </div>
    </div>

    <!-- Map and Video Container -->
     <div style="padding: 20px 20px 0 20px; background: #E31F12;">
        <div class="map-video-wrapper" [class.video-pip-mode]="isVideoPip" [class.map-maximized]="isMapMaximized">
          <!-- YouTube Video Embed -->
          <div class="video-wrapper-global" [class.video-pip]="isVideoPip" [class.video-over-maximized-map]="isMapMaximized && isVideoPip">
            <div class="video-container-inner">
              <!-- Video Stream Available -->
              <iframe 
                *ngIf="hasVideoStream && youtubeStreamUrl"
                style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none;"
                [src]="youtubeStreamUrl | safe:'resourceUrl'" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowfullscreen>
              </iframe>
              
              <!-- No Video Stream Placeholder -->
              <div class="no-transmission-overlay no-video-overlay" *ngIf="!hasVideoStream || !youtubeStreamUrl">
                <div class="no-transmission-content">
                  <div class="speedometer-icon-container">
                    <svg width="120" height="60" viewBox="0 0 100 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                      <path d="M 10 50 A 40 40 0 0 1 90 50" stroke="#999" stroke-width="4" fill="none" stroke-linecap="round"/>
                      <path d="M 50 50 L 38 25" stroke="#999" stroke-width="3" fill="none" stroke-linecap="round"/>
                      <circle cx="50" cy="50" r="4" fill="#999"/>
                    </svg>
                  </div>
                  <h2>{{ "caravan.noTransmission" | transloco }}</h2>
                  <p>{{ "caravan.noTransmissionDesc" | transloco }}</p>
                </div>
              </div>
              
              <!-- PIP Toggle Button -->
              <button *ngIf="!isMapMaximized && hasVideoStream" class="video-pip-toggle-btn" (click)="toggleVideoPip()" [title]="isVideoPip ? ('caravan.expandVideo' | transloco) : ('caravan.minimizeVideo' | transloco)">
                <svg *ngIf="!isVideoPip" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z" fill="currentColor"/>
                </svg>
                <svg *ngIf="isVideoPip" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="currentColor"/>
                </svg>
              </button>
            </div>
          </div>

          <!-- Map Container -->
          <div class="map-wrapper" [class.full-width]="isVideoPip">
            <div class="map-container">
              <div id="map"></div>
            
            <!-- Project Info Overlay 
            <div class="project-info-overlay">
              <img src="assets/img/ftCloud-FundoPreto-Textobranco.png" alt="FuelTech" class="project-icon">
              <div class="project-details">
                <span class="project-name">{{ projectName || 'Nome do projeto' }}</span>
                <span class="user-name">de {{ userName || 'nome do usuário' }}</span>
              </div>
            </div>-->

            <!-- No Transmission Placeholder (shows when no VCU stream or no transmission) -->
            <div class="no-transmission-overlay" *ngIf="!hasMapStream || !hasTransmission">
              <div class="no-transmission-content">
                <svg class="speedometer-icon" viewBox="0 0 100 50" xmlns="http://www.w3.org/2000/svg">
                  <path d="M 10 45 A 40 40 0 0 1 90 45" stroke="currentColor" stroke-width="4" fill="none" stroke-linecap="round"/>
                  <line x1="50" y1="45" x2="35" y2="20" stroke="currentColor" stroke-width="3" stroke-linecap="round"/>
                  <circle cx="50" cy="45" r="3" fill="currentColor"/>
                </svg>
                <h2>{{ "caravan.noTransmission" | transloco }}</h2>
                <p>{{ "caravan.noTransmissionDesc" | transloco }}</p>
              </div>
            </div>

            <!-- Maximize Button -->
            <button class="map-maximize-btn" (click)="toggleMapMaximize()" [title]="isMapMaximized ? ('caravan.minimizeMap' | transloco) : ('caravan.maximizeMap' | transloco)">
              <svg *ngIf="!isMapMaximized" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" fill="currentColor"/>
              </svg>
              <svg *ngIf="isMapMaximized" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" fill="currentColor"/>
              </svg>
            </button>

            <!-- Reset Zoom Button -->
            <button class="map-reset-zoom-btn" (click)="resetMapZoom()" [title]="'caravan.resetZoom' | transloco">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 5V2L8 6l4 4V7c3.31 0 6 2.69 6 6 0 2.97-2.17 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93 0-4.42-3.58-8-8-8zm-6 8c0-1.65.67-3.15 1.76-4.24L6.34 7.34C4.9 8.79 4 10.79 4 13c0 4.08 3.05 7.44 7 7.93v-2.02c-2.83-.48-5-2.94-5-5.91z" fill="currentColor"/>
              </svg>
            </button>

            <!-- Center on Car Button -->
            <button class="map-center-car-btn" 
                    [class.tracking-active]="autoTrackingEnabled"
                    (click)="centerMapOnCar()" 
                    [title]="autoTrackingEnabled ? ('caravan.autoTrackingActive' | transloco) : ('caravan.enableAutoTracking' | transloco)">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="currentColor"/>
              </svg>
              <span class="tracking-indicator" *ngIf="autoTrackingEnabled"></span>
            </button>

            <!-- Clear Path Button
            <button class="map-clear-path-btn" (click)="clearPath()" title="Limpar traçado do percurso">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
              </svg>
            </button>-->
            </div>
          </div>
        </div>
     </div>

    <!-- Telemetry Data Panel -->
    <div class="telemetry-panel">
      <div class="realtime-label">{{ "caravan.realtime" | transloco }}</div>
      
      <div class="telemetry-grid">
        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.speed" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (velocidade | number:'1.0-0') : 0 }}
            </span>
            <span class="value-unit">km/h</span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.rpm" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? Math.floor(rpm) : 0 }}
            </span>
            <span class="value-unit">RPM</span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.tps" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (tps | number:'1.0-1') : 0 }}
            </span>
            <span class="value-unit">%</span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.gear" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (marcha | number:'1.0-0') : 0 }}
            </span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.engineTemp" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (temperaturaMotor | number:'1.0-2') : '0.00' }}
            </span>
            <span class="value-unit">°C</span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.lambda" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (sonda | number:'1.2-2') : '0.00' }}
            </span>
            <span class="value-unit">λ</span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.oilPressure" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (oilpressure | number:'1.2-2') : '0.00' }}
            </span>
            <span class="value-unit">bar</span>
          </div>
        </div>

        <div class="telemetry-item">
          <div class="telemetry-label">{{ "telemetry.technical.fuelPressure" | transloco }}</div>
          <div class="telemetry-value">
            <span class="value-number" [class.no-data]="!hasTransmission">
              {{ hasTransmission ? (fuelpressure | number:'1.2-2') : '0.00' }}
            </span>
            <span class="value-unit">bar</span>
          </div>
        </div>
      </div>
    </div>
  </div>
    <!-- Description Section -->
    <div class="description-section">
      <p class="description-text" [innerHTML]="'caravan.caravanDesc' | transloco">
      </p>
    </div>

    <!-- Programming Section -->
    <div class="programming-section">
      <div class="header-tabs">
        <div class="tab active">
          {{ "caravan.schedule" | transloco }}
        </div>
      </div>
      
      <div class="program-cards">
        <div class="program-card">
          <img src="assets/img/ftvelopark/icone-bandeira.svg" alt="FuelTech" class="program-card-icon">
          <h3 class="card-title">{{ "caravan.scheduleDay1" | transloco }}</h3>
          <p class="card-subtitle">{{ "caravan.scheduleDay1Route" | transloco }}</p>
          <p class="card-description">{{ "caravan.scheduleDay1Desc" | transloco }}</p>
        </div>

        <div class="program-card">
          <img src="assets/img/ftvelopark/icone-carro.svg" alt="FuelTech" class="program-card-icon">

          <h3 class="card-title">{{ "caravan.scheduleDay2" | transloco }}</h3>
          <p class="card-subtitle">{{ "caravan.scheduleDay2Route" | transloco }}</p>
          <p class="card-description">{{ "caravan.scheduleDay2Desc" | transloco }}</p>
        </div>

        <div class="program-card">
          <img src="assets/img/ftvelopark/icone-pista.svg" alt="FuelTech" class="program-card-icon">

          <h3 class="card-title">{{ "caravan.receptionTitle" | transloco }}</h3>
          <p class="card-subtitle"></p>
          <p class="card-description">{{ "caravan.receptionDesc" | transloco }}</p>
        </div>
      </div>
    </div>

    <!-- Banner Section -->
    <div class="banner-section">
      <img src="assets/img/ftvelopark/bannerFTVelopark.svg" alt="FuelTech Velopark" class="banner-image">
    </div>

    <!-- Confirmation Section -->
    <div class="confirmation-section">
      <div class="confirmation-content">
        <p class="confirmation-title" [innerHTML]="'caravan.confirmationQuestion' | transloco">
        </p>
        
        <div class="confirmation-buttons">
          <div class="button-wrapper button-wrapper-red" (click)="openConfirmationDialog()">
            <div class="button-inner button-inner-red">
              <p-button id="btnConfirmPresence" name="btnConfirmPresence"
                [label]="'caravan.confirmPresenceBtn' | transloco"  [raised]="true"
                styleClass="custom-button"></p-button>
            </div>
          </div>
          <!-- <button class="btn-confirm-secondary"(click)="buyTicket()" >GARANTA O SEU INGRESSO </button> -->
          <div class="button-wrapper" (click)="buyTicket()">
            <div class="button-inner">
              <p-button id="btnBackLogin" name="btnBackLogin"
                [label]="'caravan.getTicketBtn' | transloco"  [raised]="true"
                styleClass="custom-button" icon="pi pi-angle-right" iconPos="right"></p-button>
            </div>
          </div>
        </div>

        <p class="confirmation-disclaimer" [innerHTML]="'caravan.ticketDisclaimer' | transloco">
        </p>
      </div>

      <h2 class="confirmed-title">{{ "caravan.confirmedPresences" | transloco }}</h2>
      
      <!-- Projects Cards Section -->
      <div class="projects-cards-section">
        <div class="card">
          <div class="cardView">
            <p-dataView 
              [layout]="'list'" 
              [value]="products()" 
              [rows]="rowsPerPage"
              [totalRecords]="totalRecords"
              [paginator]="true"
              [lazy]="true"
              (onPage)="onPageChange($event)"
              [rowsPerPageOptions]="[15, 30]" 
              [showCurrentPageReport]="true"
              [currentPageReportTemplate]="'caravan.showing' | transloco">
            
              <ng-template pTemplate="list" let-projects>
                <div class="carousel-container">
                  <div class="carousel-wrapper">
                    <div class="carousel-inner">
                      <div class="carousel-item" *ngFor="let project of projects">
                        <app-card-favorite-projects [project]="project" [user]="project.userID" [shared]="false" [detail]="true"
                        (actionFromCard)="goToPageProject(project.ownerUser, project.projectID, project.projectName)"
                        (toggleFavoriteButton)="toggleFavoriteProject(project.projectID)"
                      ></app-card-favorite-projects>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-dataView> 
          </div>
        </div>
      </div>
      <div class="confirmation-buttons">
        <div class="button-wrapper button-wrapper-red" (click)="openConfirmationDialog()">
          <div class="button-inner button-inner-red">
            <p-button id="btnConfirmPresence" name="btnConfirmPresence"
              [label]="'caravan.confirmPresenceBtn' | transloco"  [raised]="true"
              styleClass="custom-button"></p-button>
          </div>
        </div>
      </div>
    </div>


  <!-- Modal 1: Select Project -->
  <p-dialog 
    [(visible)]="showSelectProjectDialog" 
    [modal]="true" 
    [closable]="false" 
    [draggable]="false" 
    styleClass="confirmation-dialog"
    [header]="'caravan.confirmPresenceHeader' | transloco">
    
    <div class="dialog-content">
      <p class="dialog-question" [innerHTML]="'caravan.whichProject' | transloco">
      </p>
      
      <p-dropdown 
        [options]="projectOptions" 
        [(ngModel)]="selectedProjectId" 
        [placeholder]="'common.placeholders.selectProject' | transloco"
        optionLabel="name"
        optionValue="id"
        styleClass="project-dropdown"
        [style]="{'width': '100%'}"
        [appendTo]="'body'"
        [virtualScroll]="false"
        [filter]="false"
        [showClear]="false">
      </p-dropdown>
      
      <!-- <button class="btn-create-project" (click)="openCreateProjectDialog()">
        <i class="pi pi-plus"></i> Criar novo projeto
      </button> -->
      <div class="button-wrapper btn-full" (click)="openCreateProjectDialog()">
        <div class="button-inner">
          <p-button id="btnBackLogin" name="btnBackLogin"
            [label]="'caravan.createNewProject' | transloco"  [raised]="true"
            styleClass="custom-button" icon="pi pi-plus" iconPos="left"></p-button>
        </div>
      </div>
    </div>
    
    <ng-template pTemplate="footer">
      <div class="dialog-footer">
        <!-- <button class="btn-dialog-secondary" (click)="closeSelectProjectDialog()">
          <i class="pi pi-chevron-left"></i> Voltar
        </button> -->
        <div class="button-wrapper" (click)="closeSelectProjectDialog()">
          <div class="button-inner">
          <p-button id="btnBackLogin" name="btnBackLogin"
            [label]="'common.buttons.back' | transloco"  [raised]="true"
            styleClass="custom-button" icon="pi pi-chevron-left" iconPos="left"></p-button>
          </div>
        </div>
        <div class="button-wrapper button-wrapper-red" (click)="confirmPresence()">
          <div class="button-inner button-inner-red">
            <p-button id="btnConfirmDialog" name="btnConfirmDialog"
              [label]="'common.buttons.confirm' | transloco"  [raised]="true"
              styleClass="custom-button" icon="pi pi-chevron-right" iconPos="right"></p-button>
          </div>
        </div>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Modal 2: Confirmation with Project -->
  <p-dialog 
    [(visible)]="showConfirmationWithProjectDialog" 
    [modal]="true" 
    [closable]="false" 
    [draggable]="false" 
    styleClass="confirmation-dialog"
    [header]="'caravan.confirmPresenceHeader' | transloco">
    
    <div class="dialog-content dialog-success">
      <div class="success-icon">
        <i class="pi pi-check"></i>
      </div>
      
      <h3 class="success-title">{{ "caravan.presenceConfirmedTitle" | transloco }}</h3>
      
      <p class="success-message" [innerHTML]="'caravan.presenceConfirmedMsg' | transloco">
      </p>
      
      <div class="button-wrapper button-wrapper-red btn-full" (click)="buyTicket()">
        <div class="button-inner button-inner-red">
          <p-button id="btnBuyTicketModal2" name="btnBuyTicketModal2"
            [label]="'caravan.buyTicket' | transloco"  [raised]="true"
            styleClass="custom-button" icon="pi pi-chevron-right" iconPos="right"></p-button>
        </div>
      </div>
      
      <div class="divider"></div>
      
      <p class="card-instruction">
        {{ "caravan.downloadCardInstruction" | transloco }}
      </p>
      
      <!-- <button class="btn-download-card" (click)="downloadCard()">
        <i class="pi pi-download"></i> Baixar card do projeto para impressão
      </button> -->

      <div class="button-wrapper btn-full" (click)="downloadCard()">
        <div class="button-inner">
          <p-button id="btnDownloadCard" name="btnDownloadCard"
            [label]="'caravan.downloadCard' | transloco"  [raised]="true"
            [loading]="loadingCardGeneration"
            [disabled]="loadingCardGeneration"
            styleClass="custom-button" icon="pi pi-download" iconPos="left"></p-button>
        </div>
      </div>
      
      <!--<p class="share-instruction">
        {{ "caravan.shareInstruction" | transloco }}
      </p>-->
      
      <!-- <div class="social-buttons">
        <button class="social-btn instagram" (click)="shareOnSocial('instagram')">
          <i class="pi pi-instagram"></i>
          <span>Instagram Stories</span>
        </button>
        <button class="social-btn whatsapp" (click)="shareOnSocial('whatsapp')">
          <i class="pi pi-whatsapp"></i>
          <span>WhatsApp</span>
        </button>
        <button class="social-btn facebook" (click)="shareOnSocial('facebook')">
          <i class="pi pi-facebook"></i>
          <span>Facebook</span>
        </button>
        <button class="social-btn twitter" (click)="shareOnSocial('twitter')">
          <i class="pi pi-twitter"></i>
          <span>X</span>
        </button>
        <button class="social-btn threads" (click)="shareOnSocial('threads')">
          <i class="pi pi-at"></i>
          <span>Threads</span>
        </button>
      </div> -->
      
      <!-- <button class="btn-dialog-secondary btn-full" (click)="closeConfirmationWithProjectDialog()">
        <i class="pi pi-check"></i> Concluir
      </button> -->
          <div class="button-wrapper btn-full" (click)="closeConfirmationWithProjectDialog()">
            <div class="button-inner">
              <p-button id="btnBackLogin" name="btnBackLogin"
                [label]="'caravan.complete' | transloco"  [raised]="true"
                styleClass="custom-button" icon="pi pi-check" iconPos="left"></p-button>
            </div>
          </div>
    </div>
  </p-dialog>

  <!-- Modal 3: Confirmation without Project -->
  <p-dialog 
    [(visible)]="showConfirmationWithoutProjectDialog" 
    [modal]="true" 
    [closable]="false" 
    [draggable]="false" 
    styleClass="confirmation-dialog"
    [header]="'caravan.confirmPresenceHeader' | transloco">
    
    <div class="dialog-content dialog-success">
      <div class="success-icon">
        <i class="pi pi-check"></i>
      </div>
      
      <h3 class="success-title">{{ "caravan.presenceConfirmedTitle" | transloco }}</h3>
      
      <p class="success-message" [innerHTML]="'caravan.presenceConfirmedMsg' | transloco">
      </p>

      <div class="button-wrapper button-wrapper-red btn-full" (click)="buyTicket()">
        <div class="button-inner button-inner-red">
          <p-button id="btnBuyTicketModal3" name="btnBuyTicketModal3"
            [label]="'caravan.buyTicket' | transloco"  [raised]="true"
            styleClass="custom-button" icon="pi pi-chevron-right" iconPos="right"></p-button>
        </div>
      </div>
        
      <!-- <button class="btn-dialog-secondary btn-full" (click)="closeConfirmationWithoutProjectDialog()">
        <i class="pi pi-check"></i> Concluir
      </button> -->
      <div class="button-wrapper btn-full" (click)="closeConfirmationWithoutProjectDialog()">
        <div class="button-inner">
          <p-button id="btnBackLogin" name="btnBackLogin"
            [label]="'caravan.complete' | transloco"  [raised]="true"
            styleClass="custom-button" icon="pi pi-check" iconPos="left"></p-button>
        </div>
      </div>


    </div>
  </p-dialog>

  <!-- Modal 4: Create Project -->
  <app-register-project [showDialog]="showCreateProjectDialog" (closeDialog)="closeCreateProjectDialog($event)" [project]="null" [editMode]="false"></app-register-project>

  <!-- Modal 5: Fullscreen Card -->
  <div class="fullscreen-card-modal" *ngIf="showCardFullscreenModal" (keydown)="onCardModalKeydown($event)" tabindex="0">
    <div class="fullscreen-card-content">
      <!-- Close Button -->
      <button class="close-modal-btn" (click)="closeCardFullscreenModal()" [title]="'common.buttons.close' | transloco">
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="currentColor"/>
        </svg>
      </button>

      <!-- Card Container -->
      <div class="project-card-wrapper">
        <div class="project-card-container">
          <!-- Header Text -->
          <div class="card-header-text">
            <span class="header-text-line1">{{ "caravan.iWillAttend" | transloco }}</span>
          </div>

          <!-- FuelTech Logo -->
          <div class="card-logo-container">
            <img src="assets/img/ftvelopark/logoFTVelopark.svg" alt="FuelTech" class="card-fueltech-logo">
          </div>

          <!-- Main Card -->
          <div class="card-main">
            <!-- Project Image -->
            <div class="card-project-image">
              <img [src]="selectedProjectData?.photoPath || 'assets/img/default-project.jpg'" alt="Projeto" class="project-image">
            </div>

            <!-- Project Name -->
            <div class="card-project-name">
              {{ selectedProjectData?.name || ('caravan.projectName' | transloco) }}
            </div>

            <!-- User Info -->
            <div class="card-user-info">
              <div class="user-icon">
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="currentColor"/>
                </svg>
                <span class="user-label">{{ "caravan.driver" | transloco }}</span>
              </div>
              <span class="user-name-text">{{ selectedProjectData?.userName || 'NOME USUÁRIO' }}</span>
            </div>

            <!-- Button -->
            <div class="card-button-container">
              <button class="card-view-project-btn" (click)="viewProjectFromCard()">
                {{ "caravan.viewFullProject" | transloco }}
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" fill="currentColor"/>
                </svg>
              </button>
            </div>

            <!-- FT Pilot Logo -->
            <div class="card-footer-logo">
              <img src="assets/img/ftCloud-FundoPreto-Textobranco.png" alt="FT Pilot" class="ftcloud-logo">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Card Download Dialog -->
  <p-dialog 
      [(visible)]="showCardDownloadDialog" 
      [modal]="true" 
      [closable]="true" 
      [showHeader]="true"
      [header]="'caravan.downloadCardTitle' | transloco"
      [dismissableMask]="false"
      [style]="{ width: '90vw', maxWidth: '500px', padding: '0' }"
      (onHide)="closeCardDownloadDialog()">
      
      <div class="card-download-container">
          <!-- Card Preview -->
          <div id="print-card-content" class="print-card-content">
              <div class="card-header-red">
                  <!-- Header vermelho sem texto -->
              </div>
              
              <div class="card-body">
                  <h2 class="card-title">{{ "caravan.learnMore" | transloco }}</h2>
                  
                  <p class="card-instruction-qr-code" [innerHTML]="'caravan.scanQRCode' | transloco"></p>
                  
                  <div class="qr-code-container" *ngIf="qrCodeDataUrl">
                      <img [src]="qrCodeDataUrl" alt="QR Code" class="qr-code-image">
                  </div>
                  
                  <div class="ftcloud-logo-container">
                      <img src="assets/img/logo-FTCloud-red.svg" alt="FT Pilot Logo" class="ftcloud-logo-card">
                  </div>
              </div>
              
              <div class="card-footer-red">
                  <!-- Footer vermelho sem texto -->
              </div>
          </div>

          <!-- Download Buttons -->
          <div class="social-buttons">
            <button class="social-btn instagram" 
            (click)="downloadCardAsPDF()"
            [class.disabled]="downloadingPDF"
            [disabled]="downloadingPDF || downloadingWord">
              <i class="pi pi-file-pdf"></i>
              <span>{{ "caravan.downloadPDF" | transloco }}</span>
            </button>
          </div>
          <!-- <div class="download-buttons-container">
              <p class="download-instruction">Escolha o formato para download:</p>
              
              <div class="button-wrapper button-wrapper-red btn-full" 
                   (click)="downloadCardAsPDF()"
                   [class.disabled]="downloadingPDF">
                  <div class="button-inner button-inner-red">
                      <p-button 
                          label="Baixar em PDF" 
                          [raised]="true"
                          [loading]="downloadingPDF"
                          [disabled]="downloadingPDF || downloadingWord"
                          styleClass="custom-button" 
                          icon="pi pi-file-pdf" 
                          iconPos="left">
                      </p-button>
                  </div>
              </div>

              <div class="button-wrapper btn-full" 
                   (click)="downloadCardAsWord()"
                   [class.disabled]="downloadingWord">
                  <div class="button-inner">
                      <p-button 
                          label="Baixar em Word" 
                          [raised]="true"
                          [loading]="downloadingWord"
                          [disabled]="downloadingPDF || downloadingWord"
                          styleClass="custom-button" 
                          icon="pi pi-file-word" 
                          iconPos="left">
                      </p-button>
                  </div>
              </div>

              <div class="button-wrapper btn-full" (click)="closeCardDownloadDialog()">
                  <div class="button-inner">
                      <p-button 
                          label="Fechar" 
                          [raised]="true"
                          [disabled]="downloadingPDF || downloadingWord"
                          styleClass="custom-button" 
                          icon="pi pi-times" 
                          iconPos="left">
                      </p-button>
                  </div>
              </div>
          </div> -->
      </div>
  </p-dialog>

</app-dashboard-template>